import Lenis from "lenis";

let lenisInstance = null;

export function initLenis() {
  if (lenisInstance) return lenisInstance;
  lenisInstance = new Lenis({ lerp: 0.09, smoothWheel: true });
  function raf(time) {
    lenisInstance?.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenisInstance;
}

export function scrollToId(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
